import React, { PropTypes } from 'react';

import './style.scss';
import { QuestionShape } from 'entities';

class QuestionnaireQuestion extends React.Component {

  constructor(...args) {
    super(...args);

    const props = args[0];

    this.state = {
      answers: props.question && props.question.answer !== null ? props.question.answer : [],
      values: props.question  && props.question.value !== null ? props.question.value : []
    };

    this.isOptionChecked = this.isOptionChecked.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  isOptionChecked(option) {
    const { question } = this.props;
    const { answers } = this.state;

    if (question.type === 'checkbox') {
      return Boolean(answers.filter(id => id === option.id).length);
    }

    return question.answer === option.id;
  }

  handleInputChange(answerId, answerValue, event) {
    const { question } = this.props;
    const { answers, values } = this.state;


    if (question.type === 'checkbox') {
      if (
        !answers.includes(answerId) &&
        (!question.hasOwnProperty('maxNoOfAnswers') || question.maxNoOfAnswers > answers.length)
      ) {
        answers.push(answerId);
        values.push(answerValue);
      } else if (answers.includes(answerId)) {
        answers.splice(answers.indexOf(answerId), 1);
        values.splice(values.indexOf(answerValue), 1);
      }

      this.setState({ answers, values }); // eslint-disable-line react/no-set-state
    }

    const answer = question.type === 'checkbox' ? answers : answerId;
    let value;

    if (question.type === 'checkbox') value = values;
    else if (question.type === 'text') value = event.target.value;
    else value = answerValue;

    this.props.onAnswer(question, answer, value);
  }

  render() {
    const { question, title, description, tip } = this.props;
    return (
      <div className="QuestionnaireQuestion">
        <div className="inner">
        {(() => {
          if (question) {
            const name = question.id;

            return (
              <form>
                  <h5>{question.text}</h5>

                  {question.options.map((option) => {
                    const key = name + '_' + option.id;

                    return (
                      <div key={key} className="form-field radio">
                      {question.type === 'text'
                        ? <textarea
                          name={name}
                          onChange={(event) => this.handleInputChange(option.id, option.value, event)}
                        >{question.value}</textarea>
                        : <input
                          name={name}
                          type={question.type}
                          checked={this.isOptionChecked(option)}
                          onChange={(event) => this.handleInputChange(option.id, option.value, event)}
                        />
                      }
                        {question.type !== 'text' && <label
                          htmlFor={name}
                          onClick={(event) => this.handleInputChange(option.id, option.value, event)}
                        >{option.text}</label>}
                      </div>
                    );
                  })}
                </form>
            );
          }
          else {
            return (
              <div>
                <h5>{title}</h5>
                <p>{description}</p>
                <p className="instruction"><span className="icon-gesture-swipe"></span> {tip}</p>
              </div>
            );
          }
        })()}
        </div>
      </div>
    );
  }
}

QuestionnaireQuestion.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  tip: PropTypes.string,
  question: QuestionShape,
  onAnswer: PropTypes.func
};

export default QuestionnaireQuestion;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/Questionnaire/QuestionnaireQuestion/index.js
 **/